import { render } from "./FollowingView.vue?vue&type=template&id=276e895a&ts=true"
import script from "./FollowingView.vue?vue&type=script&lang=ts"
export * from "./FollowingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__